import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';
import { FullUserWithZoneParentFragment } from 'src/generated/graphql.generated';

import { UserPageSimilarCustomersSourceUser } from './user-page-similar-customers.state';

export const UserPageSimilarCustomersActions = createActionGroup({
    source: ActionSource.USER_PAGE_SIMILAR_CUSTOMERS,
    events: {
        'Tab Opened': props<{ user: UserPageSimilarCustomersSourceUser }>(),
        'Search Input Changed': props<{ value: string }>(),
        'Search Similar Customers Started': emptyProps(),
        'Search Similar Customers Success': props<{ customers: FullUserWithZoneParentFragment[] }>(),
        'Search Similar Customers Error': props<{ error: Error }>(),
        'Merge Button Clicked': props<{ user: FullUserWithZoneParentFragment }>(),
    },
});
